export default __webpack_public_path__ + "static/media/warning--loose-road-surface--g1.9cae8688.png";